import React from 'react';
import { Button, Tooltip } from 'antd';
import SyncedPropertiesAllowlist from './SyncedPropertiesAllowlist';

function AllowlistPrimaryButton({ label, loading, disabled, disabledReason, onClick }) {
  const button = (
    <Button type="primary" onClick={onClick} loading={loading} disabled={disabled}>
      {label}
    </Button>
  );
  if (disabled && disabledReason) {
    return (
      <Tooltip title={disabledReason}>
        <span>{button}</span>
      </Tooltip>
    );
  }
  return button;
}

/**
 * Checkbox table — Manage sync modal and create-token wizard step 2.
 */
export function PropertyAllowlistEditorBody(props) {
  const {
    propertyRows = [],
    selectedIds = [],
    onSelectedIdsChange,
    tableScrollY = 280,
    showSyncStatus = false,
    groupByHost = false,
    hostGroupsExtAccesses = [],
    enforceMinSelected = false,
    enforcePerHostMinSelected = false
  } = props;

  return (
    <SyncedPropertiesAllowlist
      propertyRows={propertyRows}
      selectedIds={selectedIds}
      onSelectedIdsChange={onSelectedIdsChange}
      tableScrollY={tableScrollY}
      showSyncStatus={showSyncStatus}
      groupByHost={groupByHost}
      hostGroupsExtAccesses={hostGroupsExtAccesses}
      enforceMinSelected={enforceMinSelected}
      enforcePerHostMinSelected={enforcePerHostMinSelected}
    />
  );
}

/**
 * Footer: Close + primary (e.g. Sync / Create). Optional tooltip when primary is disabled.
 */
export function PropertyAllowlistEditorActions(props) {
  const {
    onClose,
    onSaveAndSync,
    closeLabel = 'Close',
    primaryLabel = 'Save & sync now',
    primaryLoading = false,
    primaryDisabled = false,
    primaryDisabledReason
  } = props;

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap', gap: 8 }}>
      <Button onClick={onClose} disabled={primaryLoading}>
        {closeLabel}
      </Button>
      <AllowlistPrimaryButton
        label={primaryLabel}
        loading={primaryLoading}
        disabled={primaryDisabled}
        disabledReason={primaryDisabledReason}
        onClick={onSaveAndSync}
      />
    </div>
  );
}

export default PropertyAllowlistEditorBody;
